import MarkdownToJSX from "markdown-to-jsx";
import type { ReactNode } from "react";
import { memo } from "react";

import { DEFAULT_MARKDOWN_OPTIONS } from "./markdown-options.tsx";

export const Markdown = memo(
  (props: { children: ReactNode; className?: string }) => (
    <MarkdownToJSX options={DEFAULT_MARKDOWN_OPTIONS} {...props}>
      {props.children as string}
    </MarkdownToJSX>
  ),
);

Markdown.displayName = "Markdown";
